module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _vm._v(" "), _c('el-row', [(_vm.canAccess('finance|management')) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('br'), _vm._v(" "), _c('h4', [_vm._v("Total Rates")]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.rateChart,
      "donut": true,
      "thousands": ",",
      "legend": ""
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12
    }
  }, [_c('br'), _vm._v(" "), _c('h4', [_vm._v("Total Sites")]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.siteChart,
      "donut": true,
      "thousands": ",",
      "legend": "left"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": _vm.canAccess('finance|management') ? 24 : 12
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": "",
      "stripe": "",
      "show-summary": "",
      "sum-text": "Totals",
      "summary-method": _vm.summaryFormatter
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "siteGroup",
      "label": "Site Group"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('sites-popup', {
          attrs: {
            "name": scope.row.siteGroup,
            "site-group": scope.row.siteGroup,
            "status": scope.row.status
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Site Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sites",
      "label": "Sites",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), (_vm.canAccess('finance|management')) ? _c('el-table-column', {
    attrs: {
      "prop": "totalRates",
      "label": "Total Rates",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" Site Groups Report")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9f18d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sites/SiteGroupReport.vue
// module id = 1595
// module chunks = 0